import { useEffect, useState } from 'react';

export default function useAsset(
    loadFunction: (assetName: string) => any,
    assetName: string,
) {
    const [asset, setAsset] = useState<string>();
    const [loading, setLoading] = useState<boolean>(false);

    useEffect(() => {
        setLoading(true);

        (async () => {
            try {
                const loadedIcon = await loadFunction(assetName);
                if (loadedIcon) {
                    setAsset(loadedIcon.default);
                }
            } catch (ex) {
                console.error(ex);
            } finally {
                setLoading(false);
            }
        })();
    }, [assetName]);

    return { asset, isLoading: loading };
}
